import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "../../data/marketing";

export default function OperationsBridge() {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [reduce ? 0 : -35, reduce ? 0 : 35]);
  const cardY = useTransform(scrollYProgress, [0, 1], [reduce ? 0 : 30, reduce ? 0 : -30]);

  return (
    <section ref={ref} className="relative overflow-hidden bg-forest-deep py-20 text-[#FBF9F4] lg:py-28" data-testid="operations-bridge">
      <motion.img style={{ y }} src={IMAGES.operations} alt="Organized high-capacity logistics warehouse aisle for material aggregation" className="absolute inset-0 h-[115%] w-full object-cover opacity-28" />
      <div className="absolute inset-0 bg-gradient-to-r from-forest-deep via-forest-deep/82 to-forest-deep/35" />
      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-[0.95fr_0.75fr] lg:items-center">
        <div>
          <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-300">From strategy to the material stream</div>
          <h2 className="mt-3 max-w-2xl font-display text-3xl font-medium sm:text-5xl">The work has to hold up on the ground.</h2>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-emerald-100/75">Practical systems, capable service providers and reliable data connect the plan to what actually happens to the waste.</p>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-widest text-emerald-100/45">Illustrative facility image</p>
        </div>
        <motion.div style={{ y: cardY }} className="overflow-hidden rounded-[2rem] border border-white/15 bg-white/10 shadow-2xl backdrop-blur-xl">
          <img src={IMAGES.technology} alt="Systematic inventory shelving with barcode tracking infrastructure for waste batch verification" className="h-64 w-full object-cover" />
          <div className="p-5">
            <div className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-emerald-300">Advisory in context</div>
            <p className="mt-2 text-sm leading-relaxed text-emerald-100/70">Site realities, operating constraints and evidence requirements shape the mandate.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
